/**
 * Импорты
 */

import { buildRoute } from '@direct-frontend/modules-router';

export const productsImportExcelRoute = buildRoute('/products/import/excel');

export const productsRoute = buildRoute('/products');

export type ProductCardParams = { productId: string };
export const productCardRoute = buildRoute<ProductCardParams>('/product/:productId');

export type ProductVariantParams = { variantId: string };

export const productVariantRoute = buildRoute<ProductCardParams & ProductVariantParams>(
    '/product/:productId/:variantId'
);

export const productVariantStocksRoute = buildRoute<ProductCardParams & ProductVariantParams>(
    '/product/:productId/:variantId/stocks'
);
